import { Route } from "react-router-dom";

import { RequireAuth } from "../../services/auth";
import AddCompensation from "./AddCompensation";
import EmployeeCompensations from "./EmployeeCompensations";
import EditCompensation from "./EditCompensation";
import ListCompensations from "./ListCompensations";
import ViewCompensation from "./ViewCompensation";

export default (
  <Route
    path="EmployeeCompensations"
    element={
      <RequireAuth>
        <EmployeeCompensations />
      </RequireAuth>
    }
  >
    <Route
      index
      element={
        <RequireAuth>
          <ListCompensations />
        </RequireAuth>
      }
    />
    <Route
      path="new/payroll/:pId"
      element={
        <RequireAuth>
          <AddCompensation />
        </RequireAuth>
      }
    />
    <Route
      path="edit/:id/payroll/:pid"
      element={
        <RequireAuth>
          <EditCompensation />
        </RequireAuth>
      }
    />
    <Route
      path="view/:id"
      element={
        <RequireAuth>
          <ViewCompensation />
        </RequireAuth>
      }
    />
  </Route>
);
